import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LoadingService {
  private loadingSubject = new BehaviorSubject<boolean>(true);

  loading$ = this.loadingSubject.asObservable();

  private loadingTimeout!: ReturnType<typeof setTimeout>;
  private minDisplayTime = 0; // Minimum time to display the spinner in ms
  private delayTime = 0;

  setLoading(isLoading: boolean): void {
    if (isLoading) {
      clearTimeout(this.loadingTimeout);
      this.loadingTimeout = setTimeout(() => {
        this.loadingSubject.next(true);
      }, this.delayTime);
    } else {
      clearTimeout(this.loadingTimeout);
      setTimeout(() => {
        this.loadingSubject.next(false);
      }, this.minDisplayTime);
    }
  }
  // console.log('***isLoading: ', isLoading);
  // if (isLoading) {
  //   this.activeRequests++;
  // } else {
  //   this.activeRequests--;
  //   if (this.activeRequests <= 0) {
  //     this.loadingSubject.next(false);
  //     // console.log('All requests are done, hide the spinner');
  //   }
  // }
  // if (this.activeRequests > 0) {
  //   this.loadingSubject.next(true);
  //   // console.log('Show spinner if there are active requests');
  // }
}
